// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"Sidebar_btn-primary__ACH_W","root":"Sidebar_root__3TVXl","is-active":"Sidebar_is-active__HwRuF","icon":"Sidebar_icon__1vZkn"};